'use strict';
import util from '../util';


let delayTimer = null;
let lastClickedId = null;

const $productSearchResult = $('.pt_product-search-result');
const $filterCategoryID = $('#filterCategoryID');
const $filterResultsBtn = $('.filter-display-results-btn');
const $filterClearResultsBtn = $('.filter-clear-results-btn');
const $filterBodyElement = $('.filter-panel');
const $window = $(window);
const cgidVal = $filterCategoryID.val();
const currentUrl = $filterCategoryID.data('url');
let href = util.appendParamToURL(Urls.searchURL, 'cgid', cgidVal);

/**
 * Sets the width of the filter panel.
 */
function filterPanelWidth() {
    const $filterPanelWrapper = $filterBodyElement.find('.filter-panel-wrapper');
    $filterPanelWrapper.width($window.width()).css('right', -$window.width());
}

/**
 * Opens the mobile filter panel.
 * @param {Event} e - The click event.
 */
function openMobilePanel(e) {
    href = currentUrl ? `${href}&${new URL(currentUrl).search.substring(1)}` : href;
    const $filterList = $filterBodyElement.find('.filter-options-list');
    const groupName = e.currentTarget.getAttribute('data-groupname');

    let url = util.appendParamToURL(Urls.searchURL, 'groupName', groupName);  
    let currentUrlParam = $('#filterUrlParam').data('param');
    if(currentUrlParam && currentUrlParam != ''){
        url = url+'&'+(currentUrlParam);
    }
    
    filterPanelWidth();
    $filterList.empty(); // Clear the filter list before appending new items

    $.ajax({
        url: url,
        type: 'POST',
        success: (response) => {
            if (response && response.selectedGroupFilterData) {
                $filterBodyElement.find('.filter-panel-title').html(response.selectedGroupFilterData.groupName);
                response.selectedGroupFilterData.groupValues.forEach((item) => {
                    const $li = $('<li>', { class: 'filter-list-item' + ' ' + (item.enabled ? '' : 'disabled') + ' ' + (item.selected ? 'selected' : '') , 'data-groupid': response.selectedGroupFilterData.groupID, 'data-groupname': groupName, 'data-pmin': item.pmin, 'data-pmax': item.pmax, 'data-id': item.id });
                    $li.append($('<span>', { class: 'text', text: item.name }));
                    $li.append($('<i>', { class: 'icon_checkmark' }));
                    $filterList.append($li);
                });
                $filterResultsBtn.attr('href', response.selectedGroupFilterData.finalUrl);
                $filterBodyElement.addClass('opened').find('.filter-panel-wrapper').css({ right: 0 });

                if($('.filter-options-list li.selected').length > 0) {
                    $filterResultsBtn.addClass('active').find('.filter-results-number').html(response.viewAllData.viewFilteredMessage);
                    $filterClearResultsBtn.removeClass('hide').attr('href', response.selectedGroupFilterData.urlRelaxAttribute);
                }

                // After rendering filter options and updating the DOM
                const $allOptions = $filterList.find('li:not(.disabled)');
                const $selectedOptions = $allOptions.filter('.selected');

                // Add 'active' only if exactly one option or exactly one selected option
                if ($allOptions.length === 1 || $selectedOptions.length === 1) {
                    // If only one selected, prefer that, else the only option
                    const $toActivate = $selectedOptions.length === 1 ? $selectedOptions : $allOptions;
                    $toActivate.addClass('active');
                }
                $('html').addClass('filter-open');
            }
        },
        error: (status, error) => console.error('AJAX error:', status, error),
    });
}

/**
 * Handles filter option click events.
 * @param {Event} e - The click event.
 */
function filterOptionClick(e) {
    const FILTER_DEBOUNCE_DELAY = 500;
    const $li = $(e.currentTarget);
    const groupId = e.currentTarget.getAttribute("data-groupid");
    const textContent = e.currentTarget.getAttribute("data-id");
    const $checkmark = $li.find('.icon_checkmark');
    const $loader = $('.filter-panel-footer .inline-loader');
    const groupName = e.currentTarget.getAttribute('data-groupname');
    const pmin = e.currentTarget.getAttribute('data-pmin');
    const pmax = e.currentTarget.getAttribute('data-pmax');

    const cleanPageAndStartParams = updatePrefInUrl(href, groupId, textContent, groupName, pmin, pmax);
    const updatedUrl = removePageAndStartParams(cleanPageAndStartParams);
    
    if (delayTimer) clearTimeout(delayTimer);

    lastClickedId = cgidVal;

    let selectedFilterRemoved;

    delayTimer = setTimeout(() => {
        // Toggle selected state
        if ($li.hasClass('selected')) {
            $li.removeClass('selected');
            $checkmark.hide();
            href = util.appendParamToURL(removePrefFromUrl(href, groupId, textContent, groupName, pmin, pmax), 'groupName', groupName);
            selectedFilterRemoved = true;
        } else {
            $li.addClass('selected');
            $checkmark.show();
            href = util.appendParamToURL(updatedUrl, 'groupName', groupName);
            selectedFilterRemoved = false;
        }

        $loader.removeClass('hide');

        $.ajax({
            url: href,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            // Ensure response and its properties are defined before accessing them
            success: (response) => {
                if (response) {
                    const resultText = response.viewAllData.viewFilteredMessage;
                    const displayText = response.viewAllData.viewAllMessage;

                    $filterResultsBtn.attr('href', response.selectedGroupFilterData.finalUrl);
                    $filterClearResultsBtn.attr('href', response.selectedGroupFilterData.urlRelaxAttribute);

                    //Handles the redirect logic based on filter state
                    handleRedirect(
                        $li.hasClass('active'),
                        selectedFilterRemoved,
                        $filterResultsBtn.attr('href'),
                        $filterClearResultsBtn.attr('href')
                    );

                    // Check if any list item has the 'selected' class
                    if ($('.filter-options-list li.selected').length === 0) {
                        $filterClearResultsBtn.addClass('hide');
                        $filterResultsBtn.removeClass('active').find('.filter-results-number').html(displayText);
                    } else {
                        $filterResultsBtn.addClass('active').find('.filter-results-number').html(resultText);
                        $filterClearResultsBtn.removeClass('hide');
                    }
                    $loader.addClass('hide');
                } else {
                    console.warn('Response or viewAllData is undefined.');
                }
            },
            error: (error) => console.error('AJAX error:', error),
        });

        delayTimer = null;
    }, FILTER_DEBOUNCE_DELAY);
}

/**
 * Handles the redirect logic based on filter state.
 * @param {boolean} isActive - Indicates if the filter is active.
 * @param {boolean} filterRemoved - Indicates if the filter was removed.
 * @param {string} resultsHref - The URL for filtered results.
 * @param {string} clearResultsHref - The URL for cleared results.
 * @returns {boolean} - Returns true if a redirect occurred, false otherwise.
 */
function handleRedirect(isActive, filterRemoved, resultsHref, clearResultsHref) {
    // If the clicked filter (`li`) is active and a new filter is being selected (not removed),
    // redirect to the filtered results page using `resultsHref`.
    if (isActive && !filterRemoved) {
        closeFilterPanel();
        window.location.href = resultsHref;
        return true;
    }
    // If the clicked filter (`li`) is active and the filter is being removed,
    // redirect to the cleared results page using `clearResultsHref`.
    if (isActive && filterRemoved) {
        closeFilterPanel();
        window.location.href = clearResultsHref;
        return true;
    }
    return false;
}

/**
 * Removes 'page' and 'start' parameters from the given URL string.
 * @param {string} url - The original URL.
 * @returns {string} - The URL without 'page' and 'start' parameters.
 */
function removePageAndStartParams(url) {
    try {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.delete('page');
        urlObj.searchParams.delete('start');
        return urlObj.toString();
    } catch (e) {
        // Handle invalid URL input
        return url;
    }
}

/**
 * Updates a preference name/value in a given URL's query string.
 *
 * If the preference name already exists in the query string, its value is updated.
 * If the preference name does not exist, it is added to the query string.
 *
 * @param {String} url - The URL to update.
 * @param {String} newName - The name of the preference.
 * @param {String} newValue - The value of the preference.
 * @returns {String} The updated URL or null if the input URL is invalid.
 */
function updatePrefInUrl(url, newName, newValue, groupName, pmin, pmax) {
    try {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;

        // If group name is Price, add or update pmin and pmax, but DO NOT remove prefnX/prefvX pairs
        if (groupName === 'Price') {
            if (pmin) params.set('pmin', pmin);
            if (pmax) params.set('pmax', pmax);
            urlObj.search = params.toString();
            return urlObj.toString();
        }

        // Default logic for non-price filters
        let index = 1;
        while (params.has(`prefn${index}`)) {
            const paramName = params.get(`prefn${index}`);
            if (paramName === newName) {
                const prefv = params.get(`prefv${index}`);
                const existingValues = prefv ? prefv.split('|') : [];
                if (!existingValues.includes(newValue)) {
                    existingValues.push(newValue);
                    params.set(`prefv${index}`, existingValues.join('|'));
                }
                urlObj.search = params.toString();
                return urlObj.toString();
            }
            index++;
        }

        params.set(`prefn${index}`, newName);
        params.set(`prefv${index}`, newValue);
        urlObj.search = params.toString();
        return urlObj.toString();
    } catch (e) {
        // Handle invalid URL input
        return null;
    }
}
/**
 * Removes a preference name/value from a given URL's query string.
 *
 * If the preference name and value exist, the value is removed. If no values remain for that name, the pair is removed entirely.
 * The function also re-indexes the remaining prefnX/prefvX pairs to keep them sequential.
 *
 * @param {String} url - The URL to update.
 * @param {String} removeName - The name of the preference to remove.
 * @param {String} removeValue - The value of the preference to remove.
 * @returns {String} The updated URL or null if the input URL is invalid.
 */
function removePrefFromUrl(url, removeName, removeValue, groupName, pmin, pmax) {
    try {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;

        // If group name is Price, only remove pmin and pmax, do NOT touch prefnX/prefvX pairs
        if (groupName === 'Price') {
            params.delete('pmin');
            params.delete('pmax');
            urlObj.search = params.toString();
            return urlObj.toString();
        }

        // Default logic for non-price filters (remove prefnX/prefvX as before)
        let index = 1;
        const prefPairs = [];
        while (params.has(`prefn${index}`)) {
            const name = params.get(`prefn${index}`);
            const value = params.get(`prefv${index}`);
            prefPairs.push({ name, value });
            index++;
        }

        // Remove the specified value from the matching name
        const newPairs = [];
        for (const pair of prefPairs) {
            if (pair.name === removeName) {
                // Remove the value from the pipe-separated list
                const values = pair.value ? pair.value.split('|') : [];
                const filteredValues = values.filter(v => v !== removeValue);
                if (filteredValues.length > 0) {
                    newPairs.push({ name: pair.name, value: filteredValues.join('|') });
                }
                // If no values remain, omit this pair entirely
            } else {
                newPairs.push(pair);
            }
        }

        // Clear all prefnX/prefvX from params
        for (let i = 1; i < index; i++) {
            params.delete(`prefn${i}`);
            params.delete(`prefv${i}`);
        }

        // Re-add remaining pairs with sequential indices
        newPairs.forEach((pair, idx) => {
            params.set(`prefn${idx + 1}`, pair.name);
            params.set(`prefv${idx + 1}`, pair.value);
        });

        urlObj.search = params.toString();
        return urlObj.toString();
    } catch (e) {
        // Handle invalid URL input
        return null;
    }
}

/**
 * Closes the filter panel.
 */

function closeFilterPanel() {
    href = util.appendParamToURL(Urls.searchURL, 'cgid', cgidVal);
    const $panel = $(this).closest('.filter-panel');
    if ($panel.hasClass('opened')) {
        $filterClearResultsBtn.addClass('hide');
        const displayText = $filterResultsBtn.attr('title');
        $filterResultsBtn.removeClass('active')
            .find('.filter-results-number')
            .html(displayText);
        $panel.removeClass('opened').find('.filter-panel-wrapper').css({ right: -$window.width() });
        $('html').removeClass('filter-open');
    }
}

// Event Listeners
$productSearchResult.on('click', '.filter .filter-button', (e) => {
    e.preventDefault();
    openMobilePanel(e);
});

$('.filter-panel').on('click', '.filter-options-list li', (e) => {
    e.preventDefault();
    filterOptionClick(e);
});

$filterBodyElement.on('click', '.icon-close, .filter-display-results-btn, .filter-clear-results-btn', closeFilterPanel);

// Initialize
export default {
    init: function () {
        closeFilterPanel();
    }
};
